module.exports = __webpack_public_path__ + "static/img/services-strategy.749b14d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services-strategy.png
// module id = 133
// module chunks = 0